Object.defineProperty(exports, "__esModule", {
  value: true
});
var Events = {
  READY: "ready",
  RENDER: "render",
  SLOT_RENDER_ENDED: "slotRenderEnded",
  IMPRESSION_VIEWABLE: "impressionViewable",
  SLOT_VISIBILITY_CHANGED: "slotVisibilityChanged",
  SLOT_LOADED: "slotOnload"
};
exports.default = Events;